import { NotificationsOutlined } from "@mui/icons-material"
import { Button, Divider, Grid, Typography } from "@mui/material"
import { KaziAvatar } from "../Kazi/KaziAvatar"
import { useGetNotificationsQuery } from "../../Redux/api/notificationApi"
import { useUser } from "../../Hooks/useUser"
import { skipToken } from "@reduxjs/toolkit/query"
import { Fragment, useMemo } from "react"
import { formatTimestamp } from "../../Utils/String"
import { NotificationCard } from "./NotificationCard"

export const Notifications = () => {
    /* ******************** Hooks ******************** */
    const { user } = useUser();
    const { data: notifications } = useGetNotificationsQuery(user?.locator || skipToken);
    /* ******************** Variables ******************** */
    //temp variable to control notification count
    const count = useMemo(() =>{ 
        if (notifications) return notifications.length;
        return 0;
    }, [notifications])
    /* ******************** Functions ******************** */
    const handleClear = () => {
        
    }
    /* ******************** Effects ******************** */
    /* ******************** JSX ******************** */
    return (
            <Grid 
                display="flex" 
                flexDirection="column" 
                width={'300px'} 
                borderRadius={'8px'} 
            >
                <Grid display="flex" flexDirection={"row"} paddingX={'16px'} paddingY={'8px'}>
                    <Typography variant="body-small" flex={1} sx={{ paddingY: 1}}>Notifications</Typography>
                    {/* {count === 0 && 
                    <Button onClick={handleClear}>
                        <Typography variant="label-medium" flex={1} alignSelf={"flex-end"} fontWeight={'bold'} >Clear all</Typography>
                    </Button>} */}
                </Grid>
                <Divider />
                {
                    count > 0 ?
                    notifications?.map( ( n, idx ) => (
                        <NotificationCard 
                            key={n.receiver_locator + idx}
                            notification={n}
                        />
                    ))
                    :
                    <Grid display={"flex"} flexDirection={"column"} justifyContent={"center"} alignItems={"center"} gap={'12px'} marginY={'24px'}>
                        <Typography color={'green.300'}>No Notifications</Typography>
                        <NotificationsOutlined sx={{fontSize:"70px", color: 'green.200'}}/>
                    </Grid>
                }
            </Grid>
    )
}